export const baseURL = "https://rollote.lolo.global/";
export const adminBaseURL = "https://admin.lolo.global/";
export const key = "S,cU3-AZO(sc*A@F)1-tP7t[X75*j!U";